(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/betslips/competition.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/betslips/competition.js');
"use strict";

const {
  useContext
} = React;
const {
  useSelector
} = ReactRedux;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  selectUSignsCount,
  selectRequiredUSigns,
  selectCouponProductId
} = svs.components.tipsen.engine.selectors.couponSelectors;
const {
  RowsXsmallView,
  RowsView,
  HedgesXsmallView,
  HedgesView
} = svs.components.tipsen.betslip.views;
const {
  SYSTEM_MSYS,
  SYSTEM_RSYS,
  SYSTEM_USYS,
  SYSTEM_REDUCERA_FRITT
} = svs.components.tipsen.engine.constants.systems;
const {
  useGetActiveCompetitionDesc
} = svs.components.tipsen.hooks;
const Competition = _ref => {
  var _competition$details$, _competition$details;
  let {
    competition
  } = _ref;
  const {
    isExtraSmall,
    couponId
  } = useContext(BetslipContext);
  const uSigns = useSelector(state => selectUSignsCount(state, couponId));
  const requiredUSigns = useSelector(state => selectRequiredUSigns(state, couponId));
  const productId = useSelector(state => selectCouponProductId(state, couponId));
  const competitionDesc = useGetActiveCompetitionDesc(productId);
  const competitionSystemType = ((_competition$details$ = competition === null || competition === void 0 || (_competition$details = competition.details) === null || _competition$details === void 0 ? void 0 : _competition$details.systemType) !== null && _competition$details$ !== void 0 ? _competition$details$ : '').toUpperCase();
  const competitionTitle = competitionDesc !== null && competitionDesc !== void 0 ? competitionDesc : 'Tävling';
  switch (competitionSystemType) {
    case SYSTEM_REDUCERA_FRITT:
      {
        if (isExtraSmall) {
          return React.createElement(RowsXsmallView, {
            isReduced: true
          }, competitionTitle);
        }
        return React.createElement(RowsView, {
          icon: "free-reduce",
          isReduced: true
        }, React.createElement("span", null, competitionTitle));
      }
    case SYSTEM_USYS:
      {
        if (isExtraSmall) {
          return React.createElement(HedgesXsmallView, null, React.createElement("div", null, React.createElement("span", null, competitionTitle), requiredUSigns && React.createElement("span", null, ' ', React.createElement("span", {
            className: "f-400 f-bold"
          }, uSigns), React.createElement("span", {
            className: "f-400"
          }, ' ', "(", requiredUSigns, ")"))));
        }
        return React.createElement(HedgesView, {
          icon: "u-system"
        }, React.createElement(React.Fragment, null, React.createElement("span", null, competitionTitle), requiredUSigns && React.createElement("span", null, ' ', React.createElement("span", {
          className: "f-600 f-bold"
        }, uSigns), React.createElement("span", {
          className: "f-600"
        }, ' ', "(", requiredUSigns, ")"))));
      }
    case SYSTEM_RSYS:
    case SYSTEM_MSYS:
    default:
      {
        if (isExtraSmall) {
          return React.createElement(HedgesXsmallView, null, competitionTitle);
        }
        return React.createElement(HedgesView, {
          icon: "enkelrader-tur"
        }, React.createElement("span", null, competitionTitle));
      }
  }
};
setGlobal('svs.components.tipsen.betslip.betslips.Competition', Competition);

 })(window);